import React from "react";
import "./LoaderNew.css";

const Loading = ({ text = "Loading..." }) => {
  return (
    <div className="loader-wrapper" style={{ margin: "40px 0" }}>
        <div className="loader"></div>
        <p>{text}</p>
    </div>
  );
};

export default Loading;
